// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"123":"05b8ec50","425":"be6778f4","433":"e197bda1"}[chunkId] + ".css";
};